import { render, staticRenderFns } from "./SeminarEntryMessageRegisterForm.vue?vue&type=template&id=584cb124"
import script from "./SeminarEntryMessageRegisterForm.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports